import PriceList from 'components/common/helpers/PriceList';
import TransHelper from 'components/common/translations/TransHelper';

class AddressHelper {
  constructor(props) {
    this.props = props;
  }

  trans = (key, prefix = "content.bookingStep4.errors.map") => {
    return TransHelper.translate(this.props.locale, prefix + "." + key);
  }

  isDepartureValid() {
    return this.isAddressValid(this.props.departureAddress);
  }

  isReturnValid() {
    if (this.props.returnFlight) {
      if (this.props.differentReturnAddress) {
        return this.isAddressValid(this.props.returnAddress);
      } else {
        return this.isAddressValid(this.props.departureAddress);
      }
    } else {
      return true;
    }
  }

  isAddressValid(addressObject) {
    const { selectedObject, postcode, street, lat, lng } = addressObject;
    if (selectedObject === null) {
      return false;
    }

    //if is address google selected but is no all info
    return !(selectedObject.g &&
      (postcode === null ||
        street === null ||
        lat === null ||
        lng === null
      )
    );
  }

  isDeparturePriceValid() {
    return this.isInternalPriceValid(this.props.departurePrice);
  }

  isReturnPriceValid() {
    if (this.props.returnFlight) {
      return this.isInternalPriceValid(this.props.returnPrice);
    } else {
      return true;
    }
  }

  isInternalPriceValid(price) {
    return price !== null && price > 0;
  }

  isValid() {
    return this.isDepartureValid() &&
      this.isReturnValid() &&
      this.isDeparturePriceValid() &&
      this.isReturnPriceValid();
  }

  isValidDataForInput(hideReturnError) {
    var returnValid = (this.isReturnValid() && this.isReturnPostcodeHandle()) || hideReturnError;
    return this.isDepartureValid() &&
      this.isDeparturePostcodeHandle() &&
      returnValid;
  }

  isValidPrice() {
    return this.isDeparturePriceValid() && this.isReturnPriceValid();
  }

  isDeparturePostcodeHandle() {
    if (this.isDepartureValid()) {
      return this.isAddressSupported(this.props.departureAddress);
    } else {
      return false;
    }
  }

  isReturnPostcodeHandle() {
    if (this.isReturnValid()) {
      if (this.props.returnFlight) {
        if (this.props.differentReturnAddress) {
          return this.isAddressSupported(this.props.returnAddress);
        } else {
          return this.isAddressSupported(this.props.departureAddress);
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  isAddressSupported(addressObject) {
    if (addressObject.selectedObject.g) {
      var busStopName = null;
      var postcode = addressObject.postcode;
    } else {
      var busStopName = addressObject.selectedObject.value;
      var postcode = null;
    }
    var priceHelper = new PriceList(this.props.priceList);
    return priceHelper.isAddressSupported(busStopName, postcode);
  }

  getDepartureError() {
    var errors = [];
    if (!this.isDepartureValid()) {
      errors = errors.concat(this.getInteralAddressErrors(this.props.departureAddress));
    } else {
      if (!this.isDeparturePostcodeHandle()) {
        errors.push(this.trans('addressNotSupported'));
      }
    }
    if (errors.length > 0) {
      return errors[0];
    } else {
      return null;
    }
  }

  getReturnError() {
    var errors = [];
    if (this.props.returnFlight && this.props.differentReturnAddress) {
      if (!this.isReturnValid()) {
        errors = errors.concat(this.getInteralAddressErrors(this.props.returnAddress));
      } else {
        if (!this.isReturnPostcodeHandle()) {
          errors.push(this.trans('addressNotSupported'));
        }
      }
    }
    if (errors.length > 0) {
      return errors[0];
    } else {
      return null;
    }
  }

  getInteralAddressErrors(addressObject) {
    const { selectedObject, postcode, street, lat, lng } = addressObject;
    var errors = [];
    if (selectedObject === null) {
      errors.push(this.trans('addressEmpty'));
    }
    if (selectedObject !== null && selectedObject.g) {
      if (street === null) {
        errors.push(this.trans('streetNumber'));
      }
      if (postcode === null) {
        errors.push(this.trans('addressPostalCode'));
      }
      if (lat === null || lng === null) {
        errors.push(this.trans('streetCoords'));
      }
    }
    return errors;
  }
}

export default AddressHelper;
